import { AxiosResponse } from 'axios';
import { api } from 'services/companiesApi';

export const getCommunications = async (
	campaignId: string,
): Promise<AxiosResponse> => {
	return await api.get(`/questionnaires?campaignId=${campaignId}`);
};

export const getPercentage = async (
	campaignId: string,
	questionnaireId: string,
): Promise<AxiosResponse> => {
	return await api.get(
		`/campaigns/${campaignId}/questionnaires/${questionnaireId}/require-attention`,
	);
};

export const getCollaborators = async ({
	campaignId,
	questionnaireId,
	...rest
}: any): Promise<AxiosResponse> => {
	const filledFilters = Object.entries(rest).reduce((acc, [key, value]) => {
		if (
			typeof value === 'number' ||
			(typeof value === 'string' && value.length > 0)
		) {
			acc[key] = value;
		}
		return acc;
	}, {} as { [key: string]: string | number });

	return await api.get(
		`/campaigns/${campaignId}/questionnaires/${questionnaireId}/employees`,
		{ params: filledFilters },
	);
};

export const postReferEmployee = async (
	campaignId: string,
	questionnaireId: string,
	data: any,
): Promise<AxiosResponse> => {
	return await api.post(
		`/campaigns/${campaignId}/questionnaires/${questionnaireId}/refer`,
		data,
	);
};

export const getCollaboratorDetails = async (
	campaignId: string,
	employeeId: string,
	campaignAnswerId: string,
): Promise<AxiosResponse> => {
	return await api.get(
		`/campaigns/${campaignId}/employees/${employeeId}/result?campaignAnswerId=${campaignAnswerId}`,
	);
};
